<template>
    <div class="pratice-sensitive-topics-tec-content" id="identidade-verbal-na-pratica-problemas-tecnicos" data-search-anchor>      
        <div class="pratice-sensitive-topics-tec-wrapper">

            <div class="pratice-sensitive-topics-tec-container">
                <p class="pratice-tec-paragraph-title">{{ praticeReleaseParagraphTitle }}</p>
                <p class="pratice-tec-paragraph">{{ praticeReleaseParagraph1 }}</p>                        
                <p class="pratice-tec-paragraph">{{ praticeReleaseParagraph2 }}</p>                
                <p class="pratice-tec-paragraph">{{ praticeReleaseParagraph3 }}</p>                                                        
            </div>

            <div class="pratice-sensitive-topics-tec-tips-container">
                <p class="pratice-sensitive-topics-tips-paragraph-tilte">{{ praticeTipsParagraphTitle }}</p>
                <p class="pratice-tips-sensitive-topics-paragraph">{{ praticeTipsParagraph1 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph2 }}</p>
                <ThreeCircles />
                <p class="pratice-tips-sensitive-topics-paragraph">{{ praticeTipsParagraph3 }}</p>                
                <p class="pratice-tips-bold-paragraph">{{ praticeTipsParagraph4 }}</p>
                <ThreeCircles />

                <div class="pratice-legend-sensitive-topics-wrapper">
                  <div class="pratices-tips-legend-paragraph">
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph5 }}</p>
                    <p class="pratices-legend-paragraph">{{ praticeTipsParagraph6 }}</p>
                  </div>
                  
                  <div class="pratice-legend-circles">
                    <div class="pratice-line">
                      <LineGradient />
                    </div>
                    <div class="pratice-circles">
                      <ThreeCircles /><TwoCircles /><OneCircle /><BlankCircles />
                    </div>                   
                  </div>                  
                </div>           
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import BlankCircles from '@/assets/icons/BlankCircles.vue'
import LineGradient from '@/assets/icons/LineGradient.vue'
import OneCircle from '@/assets/icons/OneCircle.vue'
import ThreeCircles from '@/assets/icons/ThreeCircles.vue'
import TwoCircles from '@/assets/icons/TwoCircles.vue'
import { PageStoreContract } from '@/data/store/page.store.contract'
import PraticePageMixin from '@/mixins/pratice-page-mixin'
import { PraticePageStore } from '@/store/verbal-identity-page/pratice-store'
import { Component, Mixins } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'

@Component({components: { ThreeCircles, LineGradient, TwoCircles, OneCircle, BlankCircles }})
export default class PraticeSensitiveTopicsTecSection extends Mixins(PraticePageMixin) {
  praticePageStore: PageStoreContract = getModule(PraticePageStore, this.$store)

  get praticeReleaseParagraphTitle(): string {
    return this.getElementText(9, 0)
  }

  get praticeReleaseParagraph1(): string {
    return this.getElementText(9, 1)
  }

  get praticeReleaseParagraph2(): string {
    return this.getElementText(9, 2)
  }

  get praticeReleaseParagraph3(): string {
    return this.getElementText(9, 3)
  }

  get praticeTipsParagraphTitle(): string {
    return this.getElementText(9, 4)
  }

  get praticeTipsParagraph1(): string {
    return this.getElementText(9, 5)
  }

  get praticeTipsParagraph2(): string {
    return this.getElementText(9, 6)
  }

  get praticeTipsParagraph3(): string {
    return this.getElementText(9, 7)
  }

  get praticeTipsParagraph4(): string {
    return this.getElementText(9, 8)
  }

  get praticeTipsParagraph5(): string {
    return this.getElementText(9, 9)
  }

  get praticeTipsParagraph6(): string {
    return this.getElementText(9,  10)
  }
  
  async getPraticePage(): Promise<void> {
    await this.praticePageStore.getDataPage()
  }

  async mounted(): Promise<void> {
    if (!this.praticePageStore.isLoading) {
      await this.getPraticePage()
    }
  }
}
</script>

<style lang="scss">
.pratice-sensitive-topics-tec-content {
  display: grid;
  justify-content: center;   
  max-width: 1032px;
}

.pratice-sensitive-topics-tec-wrapper {
  position: relative; 
  display: grid;
  grid-template-columns: repeat(2, 495px);
  column-gap: 42px;
  margin-top: 60px;
  margin-bottom: 48px;
}

.pratice-sensitive-topics-tec-container {
  width: 506px;
  height: 712px;
  border-radius: 16px; 
  color: white;
  background: linear-gradient(90deg, #0079FD -37.91%, #2D51FB 20.11%, #5A29FA 78.13%, #8800F8 137.91%);
  white-space: pre;
}

.pratice-sensitive-topics-tec-tips-container {
  width: 506px;
  height: 712px;    
}

.pratice-tec-paragraph {
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;  
  margin:0 31px 22px 33px;
}

.pratice-tec-paragraph-title {
  font-weight: 700;
  font-size: 20px;  
  line-height: 24px;
  margin:31px 0 35px 29px;
  white-space: pre;
}

.pratice-sensitive-topics-tips-paragraph-tilte {
  font-weight: 800;
  font-size: 20px;  
  line-height: 17px;
  margin-top: 31px;
  margin-bottom: 94px;
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-sensitive-topics-paragraph {
  font-weight: 400;
  font-size: 16px;  
  line-height: 24px;
  margin-bottom: 0; 
  white-space: pre; 
  color: rgba(149, 149, 149, 1);
}

.pratice-tips-sensitive-topics-paragraph:nth-child(5) {
  margin-top: 94px;
}

.pratice-tips-bold-paragraph{
  font-weight: 800;
  font-size: 16px;  
  line-height: 24px;
  margin: 0;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-sensitive-topics-wrapper {
  display: flex;
  flex-direction: column;  
  margin-top: 167px;
}

.pratices-tips-legend-paragraph {
  display: flex;
  gap: 118px;              
}

.pratices-legend-paragraph {
  display: flex;
  font-weight: 600;
  font-size: 16px;  
  line-height: 100%;
  margin-top: 0;
  margin-bottom: 7px;
  color: rgba(149, 149, 149, 1);
}

.pratice-legend-circles {
  display: flex;
  flex-direction: column;
  gap: 12px;  
}

.pratice-circles{
  display: flex;
  gap: 74px;
}

</style>
